module.exports = __webpack_public_path__ + "static/logo-30e336a38a455010e5d5b1b758d2b0b4.png";